export default __webpack_public_path__ + "static/one-96667317b987773a8ac3a908805803f3.png";